"use client"
import { Component } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from "moment"
import { URL_PATH } from "../../services/API"
import API from "../../services/API"
import redux from "../../common/Redux"
import Header from "../../components/Header"
import Modal from "../../components/Modal"
import Toast from "../../components/Toast"
import Button from "@mui/material/Button"
import ReportTable from "../../components/ReportTable"

const theme = {
  background: "#02111B",
  btnColor: "#FFC857",
  blackColor: "#07070A",
  dropdownColor: "#16232C",
  greytxtcolor: "#9CA3AF",
  greybordercolor: "#374151",
  primary: "#ffc857",
  secondary: "#bb0a21",
  white: "#ffffff",
  drawerBgColor: "#16232c",
  pageBgColor: "#041A29",
  redColor: "#ed1c24",
  greenColor: "#00a651",
  blueColor: "#00a8ff",
  mutedWhite: "#9CA3AF",
  rootBgColor: "#02111b",
}

class RepeatCustomersReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      version: 1,
      loading: false,
      modalVisible: false,
      modalData: null,
      startDate: null,
      endDate: null,
      selectedSearchFilter: "",
      searchContent: "",
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  handleToastClose = () => {
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  formatDateForAPI = (date) => {
    if (!date) return ""
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }

  getSearchOptions = () => [
    { value: "", label: "Select Search Filter" },
    { value: "search_mobile", label: "Search by Mobile Number" },
    { value: "search_first_seen", label: "Search by First Seen Date" },
    // { value: "min_order_count", label: "Minimum Order Count" },
  ]

  getApiUrl = (exportType = "") => {
    const { selectedHotelId } = this.props
    const { startDate, endDate, selectedSearchFilter, searchContent } = this.state

    const fromDate = this.formatDateForAPI(startDate)
    const toDate = this.formatDateForAPI(endDate)

    return URL_PATH.report(
      selectedHotelId.id,
      "repeat_customers",
      fromDate,
      toDate,
      exportType,
      selectedSearchFilter,
      searchContent,
    )
  }

  onView = (item) => {
    this.setState({
      modalVisible: true,
      modalData: item,
    })
  }

  exportReport = async (type) => {
    const { status, message } = await API(this, "get", this.getApiUrl(type))
    if (status === "success") {
      this.showToast(message, "success")
      this.setState({
        version: this.state.version + Math.random(),
      })
    } else {
      this.showToast(message, "error")
    }
  }

  applyDateFilter = () => {
    this.setState({
      version: this.state.version + Math.random(),
    })
  }

  handleSearchChange = (searchContent) => {
    this.setState({ searchContent }, () => {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.setState({
          version: this.state.version + Math.random(),
        })
      }, 500)
    })
  }

  handleSearchFilterChange = (selectedSearchFilter) => {
    this.setState({ selectedSearchFilter, searchContent: "" }, () => {
      if (!selectedSearchFilter) {
        this.setState({
          version: this.state.version + Math.random(),
        })
      }
    })
  }

  ExampleCustomInput = ({ value, onClick, placeholder }) => (
    <button
      onClick={onClick}
      style={{
        backgroundColor: theme.dropdownColor,
        color: theme.white,
        border: `1px solid ${theme.greybordercolor}`,
        borderRadius: "4px",
        padding: "10px 16px",
        cursor: "pointer",
        fontSize: "14px",
        minWidth: "140px",
        textAlign: "left",
      }}
    >
      {value || placeholder}
    </button>
  )

  render() {
    const { modalData, modalVisible, toast, startDate, endDate } = this.state

    return (
      <div
        style={{
          backgroundColor: theme.rootBgColor,
          minHeight: "100vh",
          padding: "20px",
        }}
      >
        {/* <Header title="Repeat Customers" /> */}

        <ReportTable
          key={this.state.version}
          export={true}
          api={this.getApiUrl()}
          title="Repeat Customers Analysis"
          searchPlaceholder="Search by customer name"
          onView={this.onView}
          exportFileName="RepeatCustomers"
          dateFilter={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <DatePicker
                selected={startDate}
                onChange={(date) => this.setState({ startDate: date })}
                isClearable={false}
                closeOnScroll={true}
                placeholderText="From Date"
                customInput={<this.ExampleCustomInput />}
                dateFormat="yyyy-MM-dd"
              />
              <DatePicker
                selected={endDate}
                onChange={(date) => this.setState({ endDate: date })}
                isClearable={false}
                closeOnScroll={true}
                placeholderText="To Date"
                customInput={<this.ExampleCustomInput />}
                dateFormat="yyyy-MM-dd"
              />
              <Button
                variant="contained"
                onClick={this.applyDateFilter}
                sx={{
                  textTransform: "none",
                  backgroundColor: theme.btnColor,
                  color: theme.blackColor,
                  "&:hover": { backgroundColor: "#e6b34f" },
                  fontWeight: "500",
                  padding: "10px 20px",
                }}
              >
                Apply
              </Button>
              {(this.state.startDate || this.state.endDate) && (
                <Button
                  variant="outlined"
                  onClick={() =>
                    this.setState({
                      startDate: null,
                      endDate: null,
                      version: this.state.version + Math.random(),
                    })
                  }
                  sx={{
                    textTransform: "none",
                    borderColor: theme.greybordercolor,
                    color: theme.white,
                    "&:hover": { borderColor: theme.btnColor, backgroundColor: `${theme.btnColor}20` },
                    fontWeight: "500",
                    padding: "10px 20px",
                  }}
                >
                  Clear Dates
                </Button>
              )}
            </div>
          }
          advancedSearch={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <select
                value={this.state.selectedSearchFilter}
                onChange={(e) => this.handleSearchFilterChange(e.target.value)}
                style={{
                  backgroundColor: theme.dropdownColor,
                  color: theme.white,
                  border: `1px solid ${theme.greybordercolor}`,
                  borderRadius: "4px",
                  padding: "10px 16px",
                  fontSize: "14px",
                  minWidth: "200px",
                }}
              >
                {this.getSearchOptions().map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {this.state.selectedSearchFilter && (
                <input
                  type="text"
                  placeholder={
                    this.state.selectedSearchFilter === "search_mobile"
                      ? "Enter mobile number"
                      : this.state.selectedSearchFilter === "search_first_seen"
                        ? "Enter date (YYYY-MM-DD)"
                        : this.state.selectedSearchFilter === "min_order_count"
                          ? "Enter minimum order count"
                          : "Enter search value"
                  }
                  value={this.state.searchContent}
                  onChange={(e) => this.handleSearchChange(e.target.value)}
                  style={{
                    backgroundColor: theme.dropdownColor,
                    color: theme.white,
                    border: `1px solid ${theme.greybordercolor}`,
                    borderRadius: "4px",
                    padding: "10px 16px",
                    fontSize: "14px",
                    minWidth: "150px",
                  }}
                />
              )}
              {this.state.selectedSearchFilter && (
                <Button
                  variant="outlined"
                  onClick={() =>
                    this.setState({
                      selectedSearchFilter: "",
                      searchContent: "",
                      version: this.state.version + Math.random(),
                    })
                  }
                  sx={{
                    textTransform: "none",
                    borderColor: theme.greybordercolor,
                    color: theme.white,
                    "&:hover": { borderColor: theme.btnColor, backgroundColor: `${theme.btnColor}20` },
                    fontWeight: "500",
                    padding: "10px 20px",
                  }}
                >
                  Clear Search
                </Button>
              )}
            </div>
          }
          columns={[
            {
              title: "Name",
              key: "name",
            },
            {
              title: "Mobile No",
              key: "mobile",
              format: (val) => val || "N/A",
            },
            {
              title: "Total Orders",
              key: "order_count",
              format: (val) => val?.toLocaleString() || "0",
            },
            {
              title: "Total Spent",
              key: "total_order_amount",
              format: (val) => `₹${val?.toFixed(2) || "0.00"}`,
            },
            {
              title: "Average Rating",
              key: "avg_rating",
              format: (val) => (val > 0 ? `${val}/5 ⭐` : "No Rating"),
            },
            {
              title: "First Order",
              key: "first_order_date",
              format: (val) => (val ? moment(val).format("DD-MM-YYYY") : "N/A"),
            },
            {
              title: "Last Order",
              key: "last_order_date",
              format: (val) => (val ? moment(val).format("DD-MM-YYYY") : "N/A"),
            },
            {
              title: "Loyalty Level",
              key: "loyalty_level",
              format: (val, item) => {
                const orders = item.order_count || 0
                let level = "Bronze"
                let color = "#CD7F32"
                if (orders >= 20) {
                  level = "Platinum"
                  color = "#E5E4E2"
                } else if (orders >= 10) {
                  level = "Gold"
                  color = "#FFD700"
                } else if (orders >= 5) {
                  level = "Silver"
                  color = "#C0C0C0"
                }
                return (
                  <span
                    style={{
                      backgroundColor: color,
                      color: "#000",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    {level}
                  </span>
                )
              },
            },
          ]}
        />

        {/* Repeat Customer Details Modal */}
        {modalVisible && modalData && (
          <Modal
            visible={modalVisible}
            onClose={() => {
              this.setState({
                modalVisible: false,
                modalData: null,
              })
            }}
            title={`Repeat Customer: ${modalData.name || "Unknown"}`}
            width="90%"
          >
            <div
              style={{
                padding: "20px",
                backgroundColor: theme.background,
                color: theme.white,
                maxHeight: "80vh",
                overflowY: "auto",
              }}
            >
              {/* Repeat Customer Summary Cards */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "16px",
                  marginBottom: "24px",
                }}
              >
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Total Orders</h4>
                  <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                    {modalData.order_count?.toLocaleString() || "0"}
                  </p>
                </div>
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Total Spent</h4>
                  <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                    ₹{modalData.total_order_amount?.toFixed(2) || "0.00"}
                  </p>
                </div>
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Average Order Value</h4>
                  <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                    ₹
                    {modalData.order_count > 0
                      ? (modalData.total_order_amount / modalData.order_count).toFixed(2)
                      : "0.00"}
                  </p>
                </div>
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Average Rating</h4>
                  <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                    {modalData.avg_rating > 0 ? `${modalData.avg_rating}/5 ⭐` : "No Rating"}
                  </p>
                </div>
              </div>

              {/* Customer Details */}
              <div
                style={{
                  backgroundColor: theme.pageBgColor,
                  padding: "20px",
                  borderRadius: "8px",
                  border: `1px solid ${theme.greybordercolor}`,
                  marginBottom: "20px",
                }}
              >
                <h3 style={{ color: theme.btnColor, marginBottom: "16px" }}>Contact Information</h3>
                <div
                  style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "16px" }}
                >
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Name:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>{modalData.name || "N/A"}</p>
                  </div>
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>User ID:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px", fontFamily: "monospace" }}>
                      {modalData.user_id || "N/A"}
                    </p>
                  </div>
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Mobile:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>{modalData.mobile || "N/A"}</p>
                  </div>
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Customer Type:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>
                      <span
                        style={{
                          backgroundColor: modalData.user_id === "0" ? theme.mutedWhite : theme.greenColor,
                          color: modalData.user_id === "0" ? theme.blackColor : theme.white,
                          padding: "4px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        {modalData.user_id === "0" ? "Guest User" : "Registered User"}
                      </span>
                    </p>
                  </div>
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>First Order:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>
                      {modalData.first_order_date
                        ? moment(modalData.first_order_date).format("DD-MM-YYYY HH:mm")
                        : "N/A"}
                    </p>
                  </div>
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Last Order:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>
                      {modalData.last_order_date ? moment(modalData.last_order_date).format("DD-MM-YYYY HH:mm") : "N/A"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Loyalty Level */}
              <div
                style={{
                  backgroundColor: theme.pageBgColor,
                  padding: "20px",
                  borderRadius: "8px",
                  border: `1px solid ${theme.greybordercolor}`,
                  marginBottom: "20px",
                }}
              >
                <h3 style={{ color: theme.btnColor, marginBottom: "16px" }}>Loyalty Information</h3>
                <div
                  style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "16px" }}
                >
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Loyalty Level:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>
                      {(() => {
                        const orders = modalData.order_count || 0
                        let level = "Bronze"
                        let color = "#CD7F32"
                        if (orders >= 20) {
                          level = "Platinum"
                          color = "#E5E4E2"
                        } else if (orders >= 10) {
                          level = "Gold"
                          color = "#FFD700"
                        } else if (orders >= 5) {
                          level = "Silver"
                          color = "#C0C0C0"
                        }
                        return (
                          <span
                            style={{
                              backgroundColor: color,
                              color: "#000",
                              padding: "6px 12px",
                              borderRadius: "6px",
                              fontSize: "16px",
                              fontWeight: "bold",
                            }}
                          >
                            {level}
                          </span>
                        )
                      })()}
                    </p>
                  </div>
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Days Since Last Order:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>
                      {modalData.last_order_date
                        ? moment().diff(moment(modalData.last_order_date), "days") + " days"
                        : "N/A"}
                    </p>
                  </div>
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Order Frequency:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>
                      {modalData.first_order_date && modalData.order_count > 0
                        ? `${(modalData.order_count / Math.max(1, moment().diff(moment(modalData.first_order_date), "months", true))).toFixed(1)} orders/month`
                        : "N/A"}
                    </p>
                  </div>
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Customer Status:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>
                      <span
                        style={{
                          backgroundColor: theme.greenColor,
                          color: theme.white,
                          padding: "4px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        {modalData.order_count >= 5 ? "Loyal Customer" : "Regular Customer"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              {/* Order History */}
              {modalData.orders && modalData.orders.length > 0 && (
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "20px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h3 style={{ color: theme.btnColor, marginBottom: "16px" }}>
                    Order History ({modalData.orders.length} orders)
                  </h3>
                  <div style={{ overflowX: "auto", maxHeight: "400px", overflowY: "auto" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        backgroundColor: theme.background,
                        borderRadius: "8px",
                      }}
                    >
                      <thead style={{ position: "sticky", top: 0, backgroundColor: theme.drawerBgColor }}>
                        <tr>
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              borderBottom: `2px solid ${theme.btnColor}`,
                              color: theme.btnColor,
                              fontWeight: "600",
                            }}
                          >
                            Order ID
                          </th>
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              borderBottom: `2px solid ${theme.btnColor}`,
                              color: theme.btnColor,
                              fontWeight: "600",
                            }}
                          >
                            Order Date
                          </th>
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              borderBottom: `2px solid ${theme.btnColor}`,
                              color: theme.btnColor,
                              fontWeight: "600",
                            }}
                          >
                            Amount
                          </th>
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              borderBottom: `2px solid ${theme.btnColor}`,
                              color: theme.btnColor,
                              fontWeight: "600",
                            }}
                          >
                            Days Ago
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {modalData.orders
                          .sort((a, b) => {
                            return b.order_id - a.order_id
                          })
                          .map((order, index) => (
                            <tr
                              key={order.order_id}
                              style={{
                                backgroundColor: index % 2 === 0 ? theme.background : theme.pageBgColor,
                              }}
                            >
                              <td
                                style={{
                                  padding: "12px",
                                  borderBottom: `1px solid ${theme.greybordercolor}`,
                                  color: theme.white,
                                  fontWeight: "500",
                                }}
                              >
                                #{order.order_id}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  borderBottom: `1px solid ${theme.greybordercolor}`,
                                  color: theme.white,
                                }}
                              >
                                {order.order_date ? moment(order.order_date).format("DD-MM-YYYY HH:mm") : "N/A"}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  borderBottom: `1px solid ${theme.greybordercolor}`,
                                  color: theme.white,
                                  fontWeight: "600",
                                }}
                              >
                                ₹{order.order_amount?.toFixed(2) || "0.00"}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  borderBottom: `1px solid ${theme.greybordercolor}`,
                                  color: theme.mutedWhite,
                                  fontSize: "14px",
                                }}
                              >
                                {order.order_date
                                  ? moment().diff(moment(order.order_date), "days") + " days ago"
                                  : "N/A"}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Order Statistics */}
                  <div
                    style={{
                      marginTop: "16px",
                      padding: "16px",
                      backgroundColor: theme.drawerBgColor,
                      borderRadius: "8px",
                      border: `1px solid ${theme.greybordercolor}`,
                    }}
                  >
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                        gap: "16px",
                      }}
                    >
                      <div>
                        <strong style={{ color: theme.btnColor }}>Total Orders:</strong>
                        <span style={{ marginLeft: "8px", fontSize: "16px" }}>{modalData.orders.length}</span>
                      </div>
                      <div>
                        <strong style={{ color: theme.btnColor }}>Total Amount:</strong>
                        <span style={{ marginLeft: "8px", fontSize: "16px", fontWeight: "600" }}>
                          ₹{modalData.orders.reduce((sum, order) => sum + (order.order_amount || 0), 0).toFixed(2)}
                        </span>
                      </div>
                      <div>
                        <strong style={{ color: theme.btnColor }}>Average Order Value:</strong>
                        <span style={{ marginLeft: "8px", fontSize: "16px" }}>
                          ₹
                          {modalData.orders.length > 0
                            ? (
                                modalData.orders.reduce((sum, order) => sum + (order.order_amount || 0), 0) /
                                modalData.orders.length
                              ).toFixed(2)
                            : "0.00"}
                        </span>
                      </div>
                      <div>
                        <strong style={{ color: theme.btnColor }}>Highest Order:</strong>
                        <span style={{ marginLeft: "8px", fontSize: "16px" }}>
                          ₹{Math.max(...modalData.orders.map((order) => order.order_amount || 0)).toFixed(2)}
                        </span>
                      </div>
                      <div>
                        <strong style={{ color: theme.btnColor }}>Lowest Order:</strong>
                        <span style={{ marginLeft: "8px", fontSize: "16px" }}>
                          ₹{Math.min(...modalData.orders.map((order) => order.order_amount || 0)).toFixed(2)}
                        </span>
                      </div>
                      <div>
                        <strong style={{ color: theme.btnColor }}>Orders with Date:</strong>
                        <span style={{ marginLeft: "8px", fontSize: "16px" }}>
                          {modalData.orders.filter((order) => order.order_date).length} of {modalData.orders.length}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Modal>
        )}

        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={this.handleToastClose}
        />
      </div>
    )
  }
}

export default redux(RepeatCustomersReport)
